import { useEffect, useState } from 'react';
import {
    Modal, Divider, Typography, Box, FormControl, TextField, Card, Table, TableBody, TableCell, Container, TableContainer, TableRow, Button, TablePagination
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import Loader from 'src/components/Loader';
import moment from 'moment';
import "./../BannerManagement/BannerManagement.css"
import { GetWalletListAction, ResetWalletAmountUpdatection, WalletAmountUpdatection, WalletFilterAction } from 'src/redux/actions/TransactionsActions';
import { toast } from 'react-toastify';

export default function WalletList() {
    const dispatch = useDispatch();
    const walletData = useSelector(state => state.transaction_manager.wallet_list.data)
    const walletUpdateData = useSelector(state => state.transaction_manager.wallet_update.data)
    const loadingSelector = useSelector(state => state.transaction_manager.loading)
    const [state, setState] = useState({
        email: "",
        phone: ""
    })
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [modalValue, setModalValue] = useState(25);
    const [amount, setAmount] = useState("")
    const [open, setOpen] = useState(false);

    useEffect(() => {
        dispatch(GetWalletListAction((page + 1), rowsPerPage))
    }, [dispatch, page, rowsPerPage])

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    const setReset = () => {
        setState({
            email: "",
            phone: ""
        })
    }

    useEffect(() => {
        if (state.phone != "" || state.email != "") {
            dispatch(WalletFilterAction(state))
        } else {
            dispatch(GetWalletListAction((page + 1), rowsPerPage))
        }
    }, [state])

    const handleUpdateAmount = (value) => {
        setOpen(true);
        setModalValue(value)
    }

    const handleClose = () => {
        setOpen(false);
        setAmount("")
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "480px",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
    };

    const handleUpdateWalletAmount = (e) => {
        e.preventDefault();
        let data = {
            userid: modalValue.id,
            addamount: amount
        }
        dispatch(WalletAmountUpdatection(data))
    }

    useEffect(() => {
        if (walletUpdateData?.status) {
            toast.success(walletUpdateData.message)
            dispatch(GetWalletListAction((page + 1), rowsPerPage))
            dispatch(ResetWalletAmountUpdatection())
            setOpen(false);
        }
    }, [walletUpdateData])

    return (
        <Page title="Wallet Management">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <form autoComplete="off" onSubmit={handleUpdateWalletAmount}>
                    <Box sx={style}>
                        <Typography
                            id="modal-modal-title"
                            style={{ marginBottom: 20 }}
                            align={"center"}
                            variant="h6"
                            component="h2"
                        >
                            Update Wallet
                        </Typography>

                        <Divider />

                        <Box style={{ marginTop: 20, marginBottom: 10 }}>
                            <Typography variant="body2" component="p" style={{ marginBottom: 8 }}>User Amount : {modalValue.walletbalance} </Typography>
                            <Typography variant="body2" component="p">Wallet Type : Deposit</Typography>
                        </Box>

                        <TextField
                            required
                            onChange={({ target }) => setAmount(target.value)}
                            value={amount}
                            style={{ marginTop: 20, width: "100%" }}
                            id="outlined-basic"
                            label="Amount"
                            variant="outlined"
                            type="number"
                            inputProps={{ maxLength: 50 }}
                        />

                        <Button
                            align={"center"}
                            style={{ marginTop: 20, width: "100%" }}
                            type="submit"
                            variant="contained"
                        >
                            Update
                        </Button>
                    </Box>
                </form>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Wallet Management"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Wallet Management' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <div style={{ display: "flex" }}>
                                <div className='search-filter-block'>
                                    <div>
                                        <FormControl >
                                            <TextField
                                                onChange={({ target }) => stateHandler("email", target.value)}
                                                type="text"
                                                label="Email"
                                                variant="outlined"
                                                value={state.email}
                                            />
                                        </FormControl>
                                        <FormControl style={{ marginLeft: '10px' }}>
                                            <TextField
                                                onChange={({ target }) => stateHandler("phone", target.value)}
                                                type="text"
                                                label="Phone"
                                                variant="outlined"
                                                value={state.phone}
                                            />
                                        </FormControl>
                                    </div>

                                    <div className='reset-filter' style={{ marginLeft: 20 }}>
                                        <Button
                                            size="small"
                                            color="primary"
                                            className='btn'
                                            onClick={() => setReset()}
                                        >
                                            Reset Filter
                                        </Button>
                                    </div>

                                </div>
                            </div>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'name', label: 'User Name', alignRight: false },
                                        { id: 'email', label: 'Email', alignRight: false },
                                        { id: 'phone', label: 'Phone', alignRight: false },
                                        { id: 'bounus_amount', label: 'Bonus Amount', alignRight: false },
                                        { id: 'winning_amount', label: 'Winning Amount', alignRight: false },
                                        { id: 'deposit_amount', label: 'Deposit Amount', alignRight: false },
                                    ]}
                                />
                                <TableBody>
                                    {walletData &&
                                        walletData.data.wallet_list.sort((a, b) =>
                                            a.txdate < b.txdate ? -1 : 1
                                        ).map((value, index) => {
                                            return (
                                                <TableRow hover key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}.
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">{value.user_profile?.name ? value.user_profile.name : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value.email ? value.email : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value.phone ? value.phone : "-"}</TableCell>

                                                    <TableCell component="th" scope="row">
                                                        {value?.wltbns ? value?.wltbns : "0"}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {value?.wltwin ? value?.wltwin : "0"}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                                            <span>
                                                                {value?.walletbalance ? value?.walletbalance : "0"}
                                                            </span>
                                                            <Button variant="contained" size="small" onClick={() => handleUpdateAmount(value)}> Edit</Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={walletData && walletData.data.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
